import template from "./section-background-selector.html";

const COLOR_MODE = "color";
const IMAGE_MODE = "image";
const VIDEO_MODE = "video";

const SectionBackgroundSelectorComponent = {
  bindings: {
    model: "=",
    sectionIndex: "=",
    onChange: "&",
  },
  template: template,
  controller: class SectionBackgroundSelectorController {
    /* @ngInject */
    constructor($rootScope, $state) {
      this.$rootScope = $rootScope;
      this.$state = $state;
    }

    $onInit() {
      this.mode = COLOR_MODE;
      this.youtubeUrl = this.model.style.backgroundVideo ? this.model.style.backgroundVideo.url : undefined;
      this.enabledSound = this.model.style.backgroundVideo ? this.model.style.backgroundVideo.enabledSound : undefined;
    }

    toggleColor() {
      this.mode = COLOR_MODE;
    }

    toggleImage() {
      this.mode = IMAGE_MODE;
    }

    toggleVideo() {
      this.mode = VIDEO_MODE;
    }

    setBackgroundColorType(choice) {
      switch (choice) {
        case "primary":
          this.model.style.backgroundColorType = "primary";
          this.model.style.backgroundColor = "#ffffff00";
          this.onChange();
          break;
        case "secondary":
          this.model.style.backgroundColorType = "secondary";
          this.model.style.backgroundColor = "#ffffff00";
          this.onChange();
          break;
        case "none":
          this.model.style.backgroundColorType = "none";
          this.model.style.backgroundColor = "#ffffff00";
          this.onChange();
          break;
      }
    }

    changeBackgroundColor(color) {
      this.model.style.backgroundColorType = "custom";
      this.model.style.backgroundColor = color;
      this.onChange();
    }

    changeBackgroundImage(image) {
      if (!image) this.model.style.backgroundImage = null;
      else this.model.style.backgroundImage = image.url;
      this.onChange();
    }

    changeBackgroundVideo(video, enabledSound) {
      if (!video) this.model.style.backgroundVideo = null;
      else
        this.model.style.backgroundVideo = {
          url: video,
          enabledSound: enabledSound,
        };

      const domVideo = $(`video.quote-section-${this.sectionIndex}-video`)[0];
      if (domVideo) domVideo.load();

      this.onChange();
    }
  },
};

export default SectionBackgroundSelectorComponent;
